import { Modal } from "react-native";
import * as React from "react";

import ImageViewer from "react-native-image-zoom-viewer";
import { View, Image, StyleSheet } from "react-native";
import { Button } from "react-native";

export default class App extends React.Component {
  state = {
    showImage: true,
  };
  render() {
    return (
      <View>
        {this.state.showImage ? (
          <View style={styles.container}>
            <Image
              //   style={styles.backgroundImage}
              style={{
                width: "100%",
                height: 400,
              }}
              source={{
                uri: this.props.route.params.profileUrl,
              }}
            />
          </View>
        ) : null}
      </View>
    );
  }
}

var styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  backgroundImage: {
    flex: 1,
    resizeMode: "stretch", // or 'stretch'
  },
});
